import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  downloadUnitReport as onDownloadUnitReport,
  clearDownloadUnitReport as onClearDownloadUnitReport
} from '../../actions/downloadUnitReportActions'

const mapStateToProps = state => ({
  downloadUnitReportDataState: state.downloadUnitReport.dataState,
  downloadUnitReportErrors: get(state, ['downloadUnitReport', 'errors'], []),
})

const mapDispatchToProps = {
  onDownloadUnitReport,
  onClearDownloadUnitReport
}

const withDownloadUnitReport = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withDownloadUnitReport }